/**
 * 菜单光标样板：各场景共用的循环索引 / ↑↓ 导航 / ←→ 换值小函数。
 * 音效时机约定（与各场景历史行为一致）：
 * - menuNav：命中 ↑ 或 ↓ 边沿即播 cursor（同帧双按只播一次，引擎 30ms 去抖，与原来等价）；
 * - valueDir：命中 ← 或 → 边沿即播 cursor（不论换值是否生效——spellPractice 的用法）；
 *   只在成功换值时才播音效的场景（如 options 调音量后试听）不要用本函数，自行收尾播。
 */

/** 循环索引：(idx + dir) mod n（|dir| < n，等价于各场景手写的 (idx + n ± 1) % n）。 */
export function cycleIndex(idx, n, dir) {
  return (idx + n + dir) % n;
}

/**
 * ↑↓ 边沿导航：命中即播 cursor 并返回新索引（同帧 ↑↓ 都按则先上后下，与原两个独立 if 等价），
 * 未命中返回 null（调用处据此做"仅在移动时清错误提示"等附带动作）。
 */
export function menuNav(input, audio, idx, n) {
  let moved = false;
  if (input.pressed('up')) {
    idx = cycleIndex(idx, n, -1);
    moved = true;
  }
  if (input.pressed('down')) {
    idx = cycleIndex(idx, n, 1);
    moved = true;
  }
  if (!moved) return null;
  audio.playSfx('cursor');
  return idx;
}

/** ←→ 边沿换值：命中即播 cursor 并返回 -1/1（左优先），未命中返回 0。 */
export function valueDir(input, audio) {
  const dir = input.pressed('left') ? -1 : input.pressed('right') ? 1 : 0;
  if (dir !== 0) audio.playSfx('cursor');
  return dir;
}
